module.exports = __webpack_public_path__ + "static/media/30.c2322dd4.jpg";